export default "__VITE_ASSET__CC9P0ynL__"